module.exports = {
    handle: (e, data) => {
        if (data.gtmData) {

            const { customerId, emailAddress } = data.gtmData;

            const {
                gtmData: {
                    currencyCode,
                    product: {
                        name,
                        id,
                        price,
                        brand,
                        category,
                        quantity
                    }
                }
            } = data;

            const productData = {
                event: 'add_to_cart',
                currency: currencyCode,
                value: quantity * price,
                items: [{
                    item_name: name,
                    item_brand: brand,
                    item_category: category,
                    price: price,
                    item_id: id,
                    quantity: quantity
                }]
            }

            customerId ? productData.userId = customerId : null;
            emailAddress ? productData.email = emailAddress : null;

            dataLayer.push(productData);
        }
    }
}
